module.exports = __webpack_public_path__ + "img/contact-hero.3afec7ee.jpg";